export function AktenSidebarAssistantsPhone(props) {
    return props.children
}